var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{ref:"editor",staticStyle:{"text-align":"left"},attrs:{"disable":_vm.disabled}}),(_vm.showWordLimit && _vm.maxlength > 0)?_c('div',{staticStyle:{"margin-top":"5px","text-align":"right"}},[_c('span',{staticStyle:{"color":"#909399"}},[_vm._v(_vm._s(_vm.currentLength)+"/"+_vm._s(_vm.maxlength))])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }